const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBirthdayHat7(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450.52,
    height: "160mm",
    viewBox: "0 0 119.2 160",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M108.986 44.584c-.278-.156-.42-.348-.575-.543.258-.584.43-1.204.893-1.758.099-.116.204-.227.314-.336 1.358.248 2.554.842 3.266 1.722-.797 1.037-2.331 1.788-3.898.915zm11.19-5.62c-.906-1.915-3.87-2.906-6.579-2.434a7.422 7.422 0 0 0-4.078 2.15c-3.052-.476-6.812 1.196-8.128 3.467-.945 1.633-.811 3.383-.734 5.108.081 1.889.261 3.275 1.027 5.098-.413-.984.37-1.826-.046-2.822-.13-.304-.445-1.973-.734-2.557l.014-.058c.11-.458.261-.913.49-1.348.717-1.36 2.1-2.551 3.892-3.24a7.89 7.89 0 0 1 2.53-.507c-.188 1.127-.022 2.324.06 3.424.087 1.196.472 2.862 2.589 2.892 2.077.028 3.129-1.388 3.097-3.186-.021-1.28.159-2.817-.557-4.02a4.565 4.565 0 0 0-.512-.704c2.914-1.016 6.544-.728 7.807 1.948-.455-.964.321-2.236-.138-3.212",
    style: {
      fill: "#ffda3e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298678
    },
    transform: "translate(-39.634 -35.569)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.239 42.109c-2.78-3.91-10.453-9.04-16.57-5.159-2.92 1.854-1.983 5.905-1.975 5.93.48 4.322 5.852 4.564 7.115 3.153.473-.53.466-3.654.222-4.132-.395-.77-1.735-1.274-2.575-.579-.29.238-.025 1.303-.025 1.606 0 .109.043.372.074.655a5.367 5.367 0 0 1-1.361-.147c-1.327-.326-2.322-1.039-2.9-1.909 1.661-2.455 7.084-4.21 13.024-.728 8.28 4.858 7.349 12.553 7.134 13.751.744-4.109.497-8.699-2.163-12.441",
    style: {
      fill: "#ee3264",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298678
    },
    transform: "translate(-39.634 -35.569)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.124 54.876c-.882 1.159-2.837 1.816-4.473.76-.89-.575-.985-1.26-1.33-1.958.028-.079.056-.16.091-.238.173-.404.406-.789.688-1.158.067-.086.138-.167.208-.248 1.965.587 3.916 1.497 4.816 2.842zm7.584-6.157c-3.81-2.858-9.704-2.094-12.33.743-7.436-2.197-15.807.296-16.35 5.435-.618 5.856 2.674 7.841 6.163 8.246-.163-.018.215-2.554 0-2.58-3.31-.384-4.897-2.063-5.92-4.129.039-.119.081-.238.134-.356 1.686-3.768 7.881-5.993 14.757-4.35a4.49 4.49 0 0 0-.106.658c-.113 1.502-.31 3.365.575 4.766 1.393 2.21 5.147 1.96 5.888-.43 1.436-4.637-2.364-6.155-2.854-6.392 3.066-1.383 7.341-1.06 10.043.968-.204-.151.018-1.077.018-1.29 0-.212.18-1.14-.018-1.289",
    style: {
      fill: "#ffda3e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298678
    },
    transform: "translate(-39.634 -35.569)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.151 52.39c-.218-1.514-.938-2.842-3.1-3.899-3.433-1.679-9.448-2.415-12.637-.068-2.152 1.583-1.95 4.496-1.503 6.54-.08-.377-.074-.77-.039-1.161 1.404-5.3 13.6-4.367 16.659-.17-1.165 1.444-3.627 2.398-5.712 1.265.699.38-.737 2.807 0 3.211 2.999 1.631 6.06-.801 6.368-2.928.106-.749-.007-2.93-.036-2.79",
    style: {
      fill: "#ee3264",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298678
    },
    transform: "translate(-39.634 -35.569)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.834 178.165 100.939 52.902l-61.305 124.67s1.69 17.402 62.057 17.986c51.456.498 57.143-17.393 57.143-17.393",
    style: {
      fill: "#ee3264",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298678
    },
    transform: "translate(-39.634 -35.569)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.69 195.558c5.786.058 10.99-.121 15.675-.478L100.939 52.902l-9.82 142.363c3.305.157 6.825.258 10.572.293",
    style: {
      fill: "#ffda3e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298678
    },
    transform: "translate(-39.634 -35.569)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.04 193.108c8.69-1.77 14.612-4.264 18.63-6.712L101.738 55.038c5.648 13.686 40.036 89.035 56.32 124.64.593-.939.777-1.513.777-1.513L100.939 52.902c0 .03.015.09.04.169l31.061 140.037",
    style: {
      fill: "#ffda3e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298678
    },
    transform: "translate(-39.634 -35.569)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.338 183.096c15.268-33.999 51.216-114.193 56.85-128.134l-48.5 133.17c4.516 1.944 10.728 3.79 19.258 5.155l29.962-140.229a.934.934 0 0 0 .031-.156l-61.305 124.67s.236 2.44 3.704 5.524",
    style: {
      fill: "#ffda3e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298678
    },
    transform: "translate(-39.634 -35.569)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.907 194.445c-14.08-1.423-23.245-4.018-29.203-6.751l8.304-19.669-7.32 20.106c4.516 1.945 10.728 3.79 19.258 5.156L91.947 94.99l-12.04 99.455",
    style: {
      fill: "#f79bb3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298678
    },
    transform: "translate(-39.634 -35.569)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.946 193.287c-8.53-1.365-14.742-3.211-19.258-5.156l7.32-20.106 33.779-79.974-.84 6.939-21 98.297",
    style: {
      fill: "#ffeda0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298678
    },
    transform: "translate(-39.634 -35.569)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.534 192.567c21.28-4.972 24.29-14.371 24.3-14.402-.01.03-3.02 9.43-24.3 14.402",
    style: {
      fill: "#cdcfd1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298678
    },
    transform: "translate(-39.634 -35.569)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.39 195.568h.067-.067m.077 0a177.73 177.73 0 0 0 12.898-.488l-5.048-43.707c2.257-7.664 4.081-15.354 5.408-22.804l14.315 64.539c8.69-1.77 14.612-4.264 18.63-6.712l-30.444-81.726a101.11 101.11 0 0 0-.184-8.486c12.573 27.813 28.43 62.538 38.016 83.494.589-.931.772-1.505.776-1.513-.01.03-3.02 9.43-24.3 14.402-7.517 1.755-17.32 2.96-30.067 3.001",
    style: {
      fill: "#c0315a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298678
    },
    transform: "translate(-39.634 -35.569)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.783 195.568a282.206 282.206 0 0 1-9.99-.192c7.594-13.053 13.948-28.469 18.524-44.003l5.048 43.707c-3.923.299-8.21.473-12.898.488H103.783M132.04 193.108l-14.315-64.539c1.495-8.4 2.36-16.497 2.5-23.899l30.446 81.726c-4.019 2.448-9.942 4.942-18.63 6.712m26.017-13.43c-9.585-20.956-25.443-55.68-38.016-83.494-.014-.172-.024-.344-.038-.514l38.83 82.495c-.004.008-.187.582-.776 1.513",
    style: {
      fill: "#cdb23d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0298678
    },
    transform: "translate(-39.634 -35.569)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthdayHat7);
export default __webpack_public_path__ + "static/media/birthday_hat_7.173a182c18e6cd28190591206d26b083.svg";
export { ForwardRef as ReactComponent };